import React, { useState ,useEffect } from 'react'
// import EmailTemplate from './EmailTemplate'
// import SmsTemplate from './SMSTemplate'
import Email from './Email';
import SMS from './SMS';
import Whatsapp from './Whatsapp'
import Notification from './Notification'
import Call from './Call'
export default function Main({admin,configState}) {
    const [viewType, setViewType] = useState('whatsapp')

    useEffect(() => {
        if(configState){
            setViewType(configState)
        }

    },[configState])

    return (
        <>
        {
            viewType === 'mail' ? 
            <Email admin={admin} />
            :''
        }
        {
            viewType === 'sms'  ? 
            <SMS admin={admin} />
            :''
        }
        {
            viewType === 'whatsapp' ? 
            <Whatsapp admin={admin} />
            :''
        }
        {
            viewType === 'notification' ? 
            <Notification admin={admin} />
            :''
        }
        {
            viewType === 'call' ? 
            <Call admin={admin} />
            :''
        }
         
        </>
    )
}
